import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IQuestionnaireIntroductionSectionProps {
    questionnaireId: string;
    introduction: string;
}

class QuestionnaireIntroductionSectionState {
    public originalIntroduction: string;
    public introductionString: string;
    public isEditMode: boolean;
    public isSaving: boolean;
}

class QuestionnaireIntroductionSection extends BaseReactComponent<IQuestionnaireIntroductionSectionProps, QuestionnaireIntroductionSectionState> {
    private componentId: string = "questionnaire-form-admin-view";

    public constructor(props: Readonly<IQuestionnaireIntroductionSectionProps>) {
        super(props);
        this.state = {
            originalIntroduction: props.introduction,
            introductionString: props.introduction,
            isEditMode: false,
            isSaving: false
        };
    }

    public componentDidUpdate(prevProps: IQuestionnaireIntroductionSectionProps): void {
        if (this.props.questionnaireId === prevProps.questionnaireId && this.props.introduction === prevProps.introduction)
            return;

        this.mutateState(s => {
            s.originalIntroduction = this.props.introduction;
            s.introductionString = this.props.introduction;
            s.isEditMode = false;
            s.isSaving = false;
        });
    }

    public render(): JSX.Element {
        if (!this.state)
            return null;

        return (
            <div id={this.componentId}>
                <div style={{ borderBottom: "solid 1px #ccc", paddingLeft: "15px" }}>
                    <h4 className="thin-font">
                        {`${cacheStore.GetString("IntroductionLabel")} `}
                        {!this.state.isEditMode && <a style={{ fontSize: "14px" }} onClick={() => this.mutateState(s => s.isEditMode = true)}>{cacheStore.GetString("EDITLabel")}</a>}
                    </h4>
                </div>

                {this.state.isEditMode && (
                    <div style={{ marginBottom: "5px", padding: "15px" }}>
                        <TextAreaAutoSize
                            id="form_introduction"
                            onTextChangeCallback={(value: string) => this.mutateState(s => s.introductionString = value)}
                            value={this.state.introductionString}
                            maxHeight="150px"
                        />
                        <div className="p-footer flex-display flex-end" style={{ paddingTop: "15px" }}>
                            <ButtonGroup spacing="sm">
                                <ButtonControl
                                    className="btn btn-default"
                                    onClick={() => this.mutateState(s => {
                                        s.isEditMode = false;
                                        s.introductionString = s.originalIntroduction;
                                    })}
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    variant="brand"
                                    disabled={this.state.isSaving}
                                    onClick={() => this.handleSaveIntroduction()}
                                    label={cacheStore.GetString("SaveLabel")}
                                />
                            </ButtonGroup>
                        </div>
                    </div>
                )}
                {!this.state.isEditMode && (
                    <div style={{ padding: "15px" }}>
                        {this.state.originalIntroduction
                            ? JSXHelper.BreakStringIntoParagraphs(this.state.originalIntroduction)
                            : "--"
                        }
                    </div>
                )}
            </div>
        );
    }

    private async handleSaveIntroduction(): Promise<void> {
        this.mutateState(s => s.isSaving = true);

        const response = await Client.postAsync<any>(
            ServerOperations.Server.Myle_Admin_Questionnaire_UpdateQuestionnaireIntroduction,
            {
                QuestionnaireId: this.props.questionnaireId,
                Introduction: this.state.introductionString
            }
        );

        if (response.isSuccess) {
            this.mutateState(s => {
                s.isEditMode = false;
                s.isSaving = false;
                s.originalIntroduction = this.state.introductionString;
            });
        }
        else
            sessionStore.showPopup(response.errors);
    }
}

export { QuestionnaireIntroductionSection };
